import React, { useEffect } from 'react';
import { useTheme } from '../context/ThemeContext';

function ManageAlertsPageStyleLoader({ children }) {
  const { theme } = useTheme();

  useEffect(() => {
    const loadStyles = async () => {
      try {
        if (theme === 'dark') {
          await import('../styles/themes/dark/pages/ManageAlertsPage.css');
        } else {
          await import('../styles/themes/light/pages/ManageAlertsPage.css');
        }
      } catch (error) {
        console.error('Error loading ManageAlertsPage styles:', error);
      }
    };

    loadStyles();
  }, [theme]);

  return <>{children}</>;
}

export default ManageAlertsPageStyleLoader;
